import { memo } from 'react';
import { motion } from 'motion/react';
import { useAgentContext } from '@Providers';

import { AGENT_DURATIONS, AGENT_EASING } from '../../../Helpers/Agents/animations';

interface MessageUserProps {
  content: string;
}

const MessageUser = ({ content }: MessageUserProps) => {
  const { mode } = useAgentContext();
  const isFullscreen = mode === 'fullscreen';

  const sizing = isFullscreen
    ? 'max-w-[82%] rounded-2xl px-4 py-2.5 text-[15px]'
    : 'max-w-[80%] rounded-xl px-3 py-1.5 text-[13px]';

  return (
    <motion.div
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: AGENT_DURATIONS.fast, ease: AGENT_EASING.outExpo }}
      className="flex justify-end">
      <div
        className={`font-medium leading-relaxed text-gray-900 ${sizing}`}
        style={{
          backgroundColor: 'rgba(124, 108, 246, 0.06)',
          border: '1px solid rgba(124, 108, 246, 0.12)',
        }}>
        {content}
      </div>
    </motion.div>
  );
};

export default memo(MessageUser);
